export const isEditMode = $('body').hasClass('edit-mode');
